module.exports = __webpack_public_path__ + "img/setChecked4.e53b2b4f.png";